// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quoteSect {
  width: 100%;
  margin-bottom: 200px;
  margin-top: 300px;
}

.quoteForm {
  margin: auto 170px;
}

.subjectInput {
  width: 49%;
  margin: 5px;
}

.quoteButton {
  height: 43px;
  width: 93px;
  background-color: #F27400;
  border-color: #F27400;
  border-style: solid;
  color: white;
}

.inputLabel {
  font-weight: bold;
}

.formInput {
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.formTextArea {
  height: 100px;
}

.messageDiv {
  margin: 37px 170px;
}
.messageDiv p {
  margin: 2px;
}
.messageDiv .p2 {
  font-style: italic;
}
.messageDiv span {
  font-weight: bold;
}

@media (max-width: 768px) {
  .quoteSect {
    margin-top: 0;
    margin-bottom: 60px;
  }

  .quoteDivOriginal {
    margin-top: 40px;
    padding: 0 16px;
  }

  .rQuote {
    margin-right: 0;
    text-align: center;
  }

  .messageDiv {
    margin: 20px 0;
    width: 100%;
  }

  .quoteForm {
    margin: 0;
    width: 100%;
  }

  .subjectInput {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/CSS/Quote.scss","webpack://./src/CSS/_variables.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,oBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,WAAA;AAFJ;;AAKA;EACI,YAAA;EACA,WAAA;EACA,yBCrBY;EDsBZ,qBCtBY;EDuBZ,mBAAA;EACA,YAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,cAAA;EACA,WAAA;EACA,kCAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,wEAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;AAGI;EACI,WAAA;AADR;AAGI;EACI,kBAAA;AADR;AAGI;EACI,iBAAA;AADR;;AAKA;EAEI;IACI,aAAA;IACA,mBAAA;EAHN;;EAME;IACI,gBAAA;IACA,eAAA;EAHN;;EAME;IACI,eAAA;IACA,kBAAA;EAHN;;EAME;IACI,cAAA;IACA,WAAA;EAHN;;EAME;IACI,SAAA;IACA,WAAA;EAHN;;EAME;IACI,WAAA;EAHN;AACF","sourcesContent":["@import \"./variables\";\n\n\n.quoteSect{\n    width: 100%;\n    margin-bottom: 200px;\n    margin-top: 300px;\n}\n\n.quoteForm{\n    margin: auto 170px;\n}\n\n.subjectInput{\n    width: 49%;\n    margin: 5px;\n}\n\n.quoteButton{\n    height: 43px;\n    width: 93px;\n    background-color: $primaryOrange;\n    border-color: $primaryOrange;\n    border-style: solid;\n    color: white;\n}\n\n.inputLabel{\n    font-weight:bold ;\n}\n\n.formInput{\n    display: block;\n    width: 100%;\n    height: calc(1.5em + .75rem + 2px);\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n\n.formTextArea{\n    height: 100px;\n}\n\n.messageDiv{\n    margin: 37px 170px;\n    p{\n        margin: 2px;\n    }\n    .p2{\n        font-style: italic;\n    }\n    span{\n        font-weight: bold;\n    }\n}\n\n@media (max-width: 768px){\n\n    .quoteSect{\n        margin-top: 0;\n        margin-bottom: 60px;\n    }\n\n    .quoteDivOriginal{\n        margin-top: 40px;\n        padding: 0 16px;\n    }\n\n    .rQuote{\n        margin-right: 0;\n        text-align: center;\n    }\n\n    .messageDiv{\n        margin: 20px 0;\n        width: 100%;\n    }\n\n    .quoteForm{\n        margin: 0;\n        width: 100%;\n    }\n\n    .subjectInput{\n        width: 100%;\n    }\n}","$primaryOrange: #F27400;\n$secondaryBlue: #111E4B;\n$baseWhite: #FDFDFD;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
